import { ApiProblemError } from '@taler/api-client'

/** The server's own detail message when there is one, so a validation reason survives to the UI. */
export function problemDetail(error: Error | null): string | undefined {
  return error instanceof ApiProblemError ? error.problem.detail : undefined
}

export function isTypeMandatory(error: Error | null): boolean {
  return error instanceof ApiProblemError && error.code === 'notification.type_mandatory'
}

export function isChannelNotSupported(error: Error | null): boolean {
  return error instanceof ApiProblemError && error.code === 'notification.channel_not_supported'
}
